var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoading)?_c('div',[_vm._v("Loading data...")]):_c('ResultForm',{attrs:{"data":_vm.data},on:{"save":_vm.save}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }